module.exports = __webpack_public_path__ + "img/aguahuixquilucan.f5e4a48e.jpg";